import { useFileUploaderContext } from "@/components/file-uploader";

import type { FileUploadListProps } from "../types";

import { FileList } from "./FileList";

export function FileUploadList({ enableRetry = false }: FileUploadListProps) {
  const { files, removeFile, retryUpload } = useFileUploaderContext();

  return (
    <FileList
      files={files}
      onRemove={removeFile}
      onRetry={enableRetry ? retryUpload : undefined}
    />
  );
}
